import React,{ Component } from 'react'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { guardaCustom }  from '../actions'
import { Rnd } from 'react-rnd';
import html2canvas from 'html2canvas'
import { refStorageTemp } from "../config/firebase";
//import { getMenu,getProducto,ponesacaProducto,cambiaGal } from '../actions'


class CustomMod extends Component{

  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      alert:"",
      act:"standby",
      imgPrefix:"",
      resultado:"",
      fondocolor:"#ffffff",
      select:-1,
      formAct:1,
      formTexto:"active",
      formFoto:"",
      formTrama:"",
      printArea:{
        width_cont: 1024,
        heigth_cont: 152,
        image:"imgs/TyvekNaranjaFluo.png",
        width: '412px',
        height: '56px', 
        marginLeft:'133px',
        marginTop:'48px',
        color_fx:1, //1 MULTIPLY 2 SIN EFECTO
        color_tipo:"FC" //FC FULLCOLOR MC MONOCOLOR MN MONOCROMATICO NEGRO
      },
      objeto:{
        tipo:1,
        back:"",
        fuente:"Oswald",
        contenido:"Ingrese el Texto",
        color:"#000000",
        tamano:28,
        x:0,
        y:0,
        w:150,
        h:50
      },
      objetos:[
      ]
    }
    
    this.agregaObjeto = this.agregaObjeto.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleChangeAdd = this.handleChangeAdd.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.agregaObjeto = this.agregaObjeto.bind(this)
    this.borraObjeto = this.borraObjeto.bind(this)
    this.uploadFile = this.uploadFile.bind(this)
    this.cambiaForm = this.cambiaForm.bind(this)
    this.capturaCustom = this.capturaCustom.bind(this)
    this.guardarCustom = this.guardarCustom.bind(this)
    this.onResizeStopModulo = this.onResizeStopModulo.bind(this)
    this.onDragStopModulo = this.onDragStopModulo.bind(this)
  }
     
  componentDidMount() {
    //console.log("ACA")

    const producto = this.props.carro.find((prod)=>{
        return prod.id===this.props.match.params.id
    })

    if(this.props.carro.length<1 || producto==undefined){
        //console.log("NO HAY PRODUCTO O EL CARRO ESTA LIMPIO")
        this.props.history.push("/")
    }else{
        if(producto!==undefined && producto.hasOwnProperty("custom_objs")){
            
            this.setState({
              printArea:producto.custom_data,
              producto,
              objetos:producto.custom_objs
            })
            
        }else{
          this.setState({
            printArea:producto.custom_data,
            producto
          })
        }
    }
  }
  
  componentDidUpdate(prevProps, prevState){
    if(prevProps.actualizacion != this.props.actualizacion){
      this.props.history.push("/carro")
    }

  }

  uploadFile(tipo){
    var tipo = tipo
    this.setState(
      {
        loading:true
      },
      () => {
        const file = document.querySelector("#archivo" + tipo).files[0];
        const size = document.querySelector("#archivo" + tipo).files[0]
          .size;
        const name = +new Date() + "-" + file.name;
        const metadata = { contentType: file.type };
        if (size < 2097152) {
          const task = refStorageTemp.child(name).put(file, metadata);
          task
            .then(snapshot => snapshot.ref.getDownloadURL())
            .then(url => {
              //console.log(url);
              var objetos = Object.assign(this.state.objetos);
              var newObj = {
                tipo: tipo,
                back: "",
                fuente: url,
                contenido: "",
                color: "#000000",
                tamano: 16,
                x: 0,
                y: 0,
                w: 150,
                h: 50
              };
              if (tipo == 1) {
                newObj.fuente = "";
                newObj.back = url;
              }

              objetos.push(newObj);
              this.setState({
                objetos,
                loading: false
              });
            })
            .catch(error => {
              //console.log(error.code);
              this.setState({
                alert: error.code,
                loading: false
              });
              switch (error.code) {
                case "storage/unauthorized":
                  break;
                case "storage/canceled":
                  break;
                case "storage/unknown":
                  break;
              }
            });
        } else {
          this.setState({
            alert: "LA IMAGEN QUE INTENTA AGREGAR ES DEMASIADO GRANDE",
            loading:false
          });
        }
      }
    );
  }

  agregaObjeto(){
    var objetos = Object.assign(this.state.objetos);
    objetos.push(this.state.objeto)
    //console.log(objetos)
    this.setState({objetos})
  }

  borraObjeto(){
    var objetos = Object.assign(this.state.objetos); 
    objetos.splice(this.state.select, 1);
    if(objetos.length>0){
      this.setState({objetos,select: -1});
    }else{
      this.setState({select: -1});
    }
  }

  capturaCustom(){
    //console.log("CAPTURA")
    html2canvas(document.querySelector("#canva")).then(canvas => {
        let imgData = canvas.toDataURL('image/png');
        this.setState({resultado:imgData})
    });
  }

  guardarCustom(){
    console.log(this.state.objetos);
    this.props.guardaCustom(this.props.match.params.id,this.state.objetos)
  }


  handleChange(event) {
    var objetos = Object.assign(this.state.objetos); 
    objetos[this.state.select][event.target.name] =event.target.value; 
    this.setState({ objetos });
  }

  handleChangeAdd(event) {
    var objeto = this.state.objeto
    objeto[event.target.name]=event.target.value
    this.setState({ objeto });
  }

  handleSubmit(event) {
    if (this.state.objeto.fuente=="") {
      this.setState({
        alert:"DEBE ELEGIR UNA TIPOGRAFIA"
      })
    } else if (this.state.objeto.color == "") {
      this.setState({
        alert: "DEBE ELEGIR COLOR"
      })
    }else{
      var objetos = Object.assign(this.state.objetos);
      objetos.push(this.state.objeto)
      //console.log(objetos)
      this.setState({objetos,alert:""})
    }
      event.preventDefault();
  }

  cambiaForm(e){
    //console.log(e.target)
    if(e.target.name=="texto"){
      this.setState({formAct:1,formTexto:"active",formFoto:"",formTrama:""})
    }else if(e.target.name=="trama"){
      this.setState({formAct:3,formTexto:"",formFoto:"",formTrama:"active"})
    }else if(e.target.name=="foto"){
      this.setState({formAct:2,formTexto:"",formFoto:"active",formTrama:""})
    }
    e.preventDefault()
  }

  onResizeStopModulo(dato){
    var objwh = Object.assign({}, this.state.objeto);
    objwh.w=dato.style.width
    objwh.h=dato.style.height
   // console.log(objwh)
    const objsWH = this.state.objetos.map((obj,i)=>{
      console.log(i+">"+this.state.select);
      if(i===this.state.select){
        console.log("AGREGAAAAA")
        return objwh
      }else{
        return obj
      }
    })
    this.setState({ 
      objeto:objwh,
      objetos:objsWH 
    });
  }

  nuevoElemento = () => {
    this.setState({
      select: -1,
      objeto: {
        tipo: 1,
        back: "",
        fuente: "Oswald",
        contenido: "Ingrese el Texto",
        color: "#000000",
        tamano: 28,
        x: 0,
        y: 0,
        w: 150,
        h: 50
      },
    })
  }

  onDragStopModulo(x,y){
    var objXY = Object.assign({}, this.state.objeto);
    objXY.x=x
    objXY.y=y
    const objsXY = this.state.objetos.map((obj,i)=>{
      if(i===this.state.select){
        return objXY
      }else{
        return obj
      }
    })
    this.setState({
      objeto:objXY,
      objetos:objsXY
    }) 
  }

  render() {
    var class_fx=""
    if(this.state.color_fx === 1){
      class_fx="backCustomApp"
    }
    const  objetos = this.state.objetos.map((objeto,i)=>{
      var tamano=parseInt(this.state.objetos[i].tamano)
        if(objeto.tipo==1){
          return (
            <Rnd
              default={{
                x: objeto.x,
                y: objeto.y,
                width: objeto.w,
                height: objeto.h,
              }}
              minWidth={2}
              minHeight={2}
              bounds="parent"
              onDragStart={()=>{
                this.setState({
                  select:i,
                  objeto:this.state.objetos[i]
                })
              }}
              onDragStop={(e, d) => { 
                this.onDragStopModulo(d.x,d.y)
              }}
              onResizeStart={(e, direction, ref, delta, position) => {
                this.setState({
                  select: i,
                  objeto: this.state.objetos[i]
                })
              }}
              onResizeStop={(e, direction, ref, delta, position) => {
                this.onResizeStopModulo(ref)
              }}
              key={i}
            >
              <div style={{border: '1px dotted #ddd',margin: 0, height: '100%',backgroundImage:this.state.objetos[i].back,overflow:'hidden'} }  className="imgCustomApp">
                <h2 className="sinBlend" style={{fontSize:parseInt(this.state.objetos[i].tamano),color:this.state.objetos[i].color,fontFamily:this.state.objetos[i].fuente}}  dangerouslySetInnerHTML={{__html:this.state.objetos[i].contenido.replace(/\r?\n/g, '<br />')}}></h2> 
              </div>
            </Rnd>
          )
        }else if(objeto.tipo==2){
          return (
            <Rnd
              default={{
                x: objeto.x,
                y: objeto.y,
                width: objeto.w,
                height: objeto.h,
              }}
              minWidth={2}
              minHeight={2}
              bounds="parent"
              onDragStart={()=>{this.setState({
                select:i,
                objeto: this.state.objetos[i]})}}
              onDragStop={(e, d) => {
                this.onDragStopModulo(d.x, d.y)
              }}
              onResizeStart={(e, direction, ref, delta, position) => {
                this.setState({
                  select: i,
                  objeto: this.state.objetos[i]
                })
              }}
              onResizeStop={(e, direction, ref, delta, position) => {
                this.onResizeStopModulo(ref)
              }}
              key={i}
            >
              <div style={{border: '1px dotted #ddd',margin: 0, height: '100%', backgroundImage:this.state.objetos[i].back}} className="imgCustomApp">
                <img src={this.state.objetos[i].fuente} style={{width:'100%', height:"100%"}} className="imgCustomApp"/>
              </div>
            </Rnd>
          )
        }
      })


    return (
      <section className="container-fluid mb-5 sombraHead mt-3 clearfix" >
        { this.state.alert!="" && 
           <div className="alert alert-danger" role="alert">{ this.state.alert }</div>
        }
        <section style={{backgroundImage:'url("https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/custom%2F'+this.props.match.params.id+'.png?alt=media")',width:this.state.printArea.width_cont,height:this.state.printArea.heigth_cont, marginTop:60, marginBottom:30,paddingTop:this.state.printArea.marginTop }} id="canva" className={class_fx}>
          <section  style={{
              width: this.state.printArea.width,
              height: this.state.printArea.height, 
              marginLeft:this.state.printArea.marginLeft
            }} className={class_fx+" printArea"}>
            {objetos}
          </section>
        </section>


        { this.state.select>-1 ?

        <section>
            <div className="row mb-3">
              <div className="col">
                <button type="button" className="btn btn-primary" onClick={this.nuevoElemento} >NUEVO ELEMENTO</button>
              </div>
            </div>
        { this.state.objetos[this.state.select].tipo===1 ?
        <div className="card mt-3">
              <div className="card-body">
        <form onSubmit={e => { e.preventDefault(); }}>
         <div className="form-row">
            <div className="col">
              <button type="button" className="btn btn-danger" onClick={this.borraObjeto} >BORRA ELEMENTO</button>  
            </div>
          </div>
          <div className="form-group">
            <label>Modifica Texto</label>
            <textarea className="form-control" name="contenido" value={this.state.objetos[this.state.select].contenido} onChange={this.handleChange} />
            </div>
            <div className="form-row">
              <div className="col">    
                <label>TIPOGRAFIA</label>        
                <select className="form-control" name="fuente" value={this.state.objetos[this.state.select].fuente} onChange={this.handleChange}>
                  <option value='Noto Serif KR'>Noto Serif KR</option>
                  <option value='Oswald'>Oswald</option>
                  <option value='Roboto Slab'>Roboto Slab</option>
                  <option value='Lobster'>Lobster</option>
                  <option value='Pacifico'>Pacifico</option>
                </select>
              </div>
              <div className="col">
              <label>TAMAÑO</label>
                        <input className="form-control" name="tamano" type="number" value={this.state.objetos[this.state.select].tamano} onChange={this.handleChange} onKeyPress={(e) => { e.target.keyCode === 13 && e.preventDefault(); }} />
              </div>
                      <div className="col mb-2"> 
                <label>COLOR</label>           
                  
                  { this.state.printArea.color_tipo == "MC" &&
                  <select className="form-control" name="color" value={this.state.objeto.color} onChange={this.handleChangeAdd}>
                    <option value="#1b98e4">AZUL</option>
                    <option value="#008000">VERDE</option>
                    <option value="#d62737">ROJO</option>
                    <option value="#000000">NEGRO</option>
                  </select>
                  }

                  { this.state.printArea.color_tipo == "FC" &&
                    <select className="form-control" name="color" value={this.state.objeto.color} onChange={this.handleChangeAdd}>
                    <option value="#1b98e4">AZUL</option>
                    <option value="#008000">VERDE</option>
                    <option value="#d62737">ROJO</option>
                    <option value="#000000">NEGRO</option>
                    </select>
                  }

                  { this.state.printArea.color_tipo == "MN" &&
                  <select className="form-control" name="color" value={this.state.objeto.color} onChange={this.handleChangeAdd}>
                    <option value="#ffffff">BLANCO</option>
                    <option value="#000000">NEGRO</option>
                    </select>
                  }
              </div>
            </div>
          </form>
          </div>
          </div>
          :
          <div className="col">
            <button type="button" className="btn btn-danger" onClick={this.borraObjeto} >BORRA ELEMENTO</button>  
          </div>
        }

        </section>
:
        <section>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a className={"nav-link "+this.state.formTexto} href="#" name="texto" onClick={this.cambiaForm}>TEXTO</a>
            </li>
            <li className="nav-item">
              <a className={"nav-link "+this.state.formFoto} href="#" name="foto" onClick={this.cambiaForm}>FOTO</a>
            </li>
          </ul>

          { this.state.formAct==2 &&
              <div className="card mt-3">
                <div className="card-body">
          <form onSubmit={e => { e.preventDefault(); }}>
            <label >FOTO</label>
            <input className="form-control" type="file" id="archivo2" className="form-control"  accept="image/*"/>
            <small id="emailHelp" className="form-text text-muted">PESO MAXIMO DE LA IMAGEN 2MB</small>
            {this.state.loading ?
            <h4>AGUARDE UN INSTANTE...</h4>
            :
            <button type="button" className="btn btn-primary" onClick={(e)=>this.uploadFile(2)} >SUBIR</button>
            }
          </form>
          </div></div>
          }

          { this.state.formAct==1 &&
              <div className="card mt-3">
                <div className="card-body">
          <form onSubmit={this.handleSubmit} id="textoForm">
            <div className="form-group">
              <label >Texto</label>
              <textarea className="form-control" name="contenido" value={this.state.objeto.contenido} onChange={this.handleChangeAdd} />
            </div>

            <div className="form-row">
              <div className="col">     
              <label>TIPOGRAFIA</label>       
              <select className="form-control" name="fuente" value={this.state.objeto.fuente} onChange={this.handleChangeAdd}>
                < option value = '' > SELECCIONAR < /option>
                <option value='Noto Serif KR'>Noto Serif KR</option>
                <option value='Oswald'>Oswald</option>
                <option value='Roboto Slab'>Roboto Slab</option>
                <option value='Lobster'>Lobster</option>
                <option value='Pacifico'>Pacifico</option>
              </select>
              </div>
              <div className="col">
              <label>TAMAÑO</label>
                        <input className="form-control" name="tamano" type="number" value={this.state.objeto.tamano} onChange={this.handleChangeAdd} onKeyPress={(e) => { e.target.keyCode === 13 && e.preventDefault(); }}/>
              </div>
              <div className="col mb-2"> 
                <label>COLOR</label>           
                  { this.state.printArea.color_tipo == "MC" &&
                  <select className="form-control" name="color" value={this.state.objeto.color} onChange={this.handleChangeAdd}>
                    < option value = '' > SELECCIONAR < /option>
                    <option value="#1b98e4">AZUL</option>
                    <option value="#008000">VERDE</option>
                    <option value="#d62737">ROJO</option>
                    <option value="#000000">NEGRO</option>
                  </select>
                  }

                  { this.state.printArea.color_tipo == "FC" &&
                    <select className="form-control" name="color" value={this.state.objeto.color} onChange={this.handleChangeAdd}>
                    < option value = '' > SELECCIONAR < /option>
                    <option value="#1b98e4">AZUL</option>
                    <option value="#008000">VERDE</option>
                    <option value="#d62737">ROJO</option>
                    <option value="#000000">NEGRO</option>
                    </select>
                  }

                  { this.state.printArea.color_tipo == "MN" &&
                  <select className="form-control" name="color" value={this.state.objeto.color} onChange={this.handleChangeAdd}>
                    < option value = '' > SELECCIONAR < /option>
                    <option value="#ffffff">BLANCO</option>
                    <option value="#000000">NEGRO</option>
                    </select>
                  }
              </div>
            </div>
            <button type="submit" className="btn btn-primary" >AGREGAR OBJETO</button>
          </form>
        </div></div>
        }
        </section>
}
        <div className="row  mt-3">
           <div className="col">
            <button type="button" className="btn btn-primary" onClick={this.guardarCustom} >GUARDAR CUSTOM</button>
          </div>
          
          { 1===2 &&
          <div className="col">
            <button type="button" className="btn btn-primary" onClick={this.capturaCustom} >GENERA IMAGEN CUSTOM</button>
          </div>
          }

          { this.state.resultado !="" &&
          <div className="col">
            <a href={this.state.resultado} className="btn btn-primary" >DESCARGAR</a>
          </div>
          }
        </div>

        <div className="clearfix  mt-3">
        <img src={this.state.resultado} />
        </div>
      </section>

    )
  }
}

const mapStateToProps = (state, ownProps) => {
    return {
      carro: state.productos.carro,
      actualizacion: state.productos.actualizacion,
      usuario: state.usuario
    }
}

const mapDispatchToProps = dispatch => {
  return {
    guardaCustom:(id_prod, customObjs) => {
      dispatch(guardaCustom(id_prod, customObjs))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomMod)




// WEBPACK FOOTER //
// ./src/containers/customod.js